module.exports = __webpack_public_path__ + "static/media/folder-bulk-remove.ac5bfb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/folder-bulk-remove.png
// module id = 1489
// module chunks = 0